/**
 * <locale-modal> — opens the country and currency panel (snippets/locale-modal.liquid).
 *
 * The panel is a native <dialog>, so Escape and the focus trap come from the platform; this element
 * only wires the trigger, the close button and a click on the backdrop. Choosing a country submits
 * Shopify's localization form, so the panel works without JavaScript once it is open.
 */
class LocaleModal extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-locale-dialog]');
    this.trigger = this.querySelector('[data-locale-open]');
    if (!this.dialog || !this.trigger) return;
    this.trigger.addEventListener('click', () => this.dialog.showModal());
    this.querySelector('[data-locale-close]')?.addEventListener('click', () => this.dialog.close());
    this.dialog.addEventListener('click', (event) => {
      // a click that lands on the dialog element itself is a click on the backdrop
      if (event.target === this.dialog) this.dialog.close();
    });
  }
}

if (!customElements.get('locale-modal')) customElements.define('locale-modal', LocaleModal);
